import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem'
import SvgDropDownArrow from '@material-ui/icons/ExpandMore';

const styles = (theme) => {
    return {
        label: {
            display: 'inline-block',
            position: 'relative',
            top: 1,
            bottom: 0,
            left: 0,
            height: 28,
            lineHeight: '28px',
            fontSize: 12,
            fontVariant: 'small-caps',
            textTransform: 'uppercase',
            cursor: 'default',
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
        },
        select: {
            display: 'inline-block',
            position: 'relative',
            bottom: 0,
            left: 12,
            height: 28,
            lineHeight: '28px',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 400,
            fontVariant: 'small-caps',
            textTransform: 'uppercase',
            verticalAlign: 'middle',
        },
        selectRoot: {
            width: '100%',
            height: '100%',
        },
        selectDisplay: {
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 32,
            '&$selectDisabled': {
                color: theme.palette.text.disabled,
            },
            '&:focus': {
                backgroundColor: theme.palette.common.transparent,
            }
        },
        selectMenu: {
            backgroundColor: theme.palette.background.paper,
            maxHeight: '40%',
        },
        selectMenuList: {
            margin: 0,
            padding: 0,
            backgroundColor: theme.palette.background.paper,
        },
        selectMenuItem: {
            fontSize: 13,
            margin: 0,
            paddingTop: 2,
            paddingBottom: 2,
            paddingLeft: 16,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
                backgroundColor: theme.palette.primary.hoverOverlay,
            },
            '&$selectSelected': {
                color: theme.palette.primary.selectedDisplayText,
            },
            '&$selectSelected:not(:hover)': {
                backgroundColor: theme.palette.background.paper,
            }
        },
        selectIcon: {
            ...theme.iconStyle.size[18],
            position: 'absolute',
            top: 'calc(50% - 9px)',
            right: 0,
            marginRight: 8,
            pointerEvents: 'none',
            color: theme.palette.text.primary,
            '&$selectDisabled': {
                color: theme.palette.text.disabled,
            }
        },
        selectDefault: {},
        selectDisabled: {},
        selectSelected: {},
        inputError: {},
        inputFocused: {},
        inputDisabled: {},
    };
}

class SelectRegion extends Component {
    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.props.regionListTimestamp !== nextProps.regionListTimestamp ||
            this.props.disabled !== nextProps.disabled ||
            this.props.regionIndex !== nextProps.regionIndex);
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div className={this.props.className}>
                <Typography
                    className={classes.label}
                    align='left'
                >
                    Area
                </Typography>
                {this._renderDropDown()}
            </div>
        );
    }

    _renderDropDown = () => {
        const {classes} = this.props;

        const selectClasses = {
            root: classes.selectRoot,
            select: classes.selectDisplay,
            disabled: classes.selectDisabled,
        };

        const inputClasses = {
            error: classes.inputError,
            focused: classes.inputFocused,
            disabled: classes.inputDisabled,
        };

        const menuProps = {
            classes: {
                paper: classes.selectMenu,
            },
            MenuListProps: {
                className: classes.selectMenuList,
            },
            PopoverClasses: {
            },
            getContentAnchorEl: null,
            anchorReference: 'anchorEl',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
        };

        return (
            <Select
                className={classes.select}
                classes={selectClasses}
                input={<Input classes={inputClasses} disableUnderline={true}/>}
                MenuProps={menuProps}
                IconComponent={this._renderDropDownArrow}
                value={(this.props.regionList.length === 0) ? -1 : this.props.regionIndex}
                onChange={this._handleSelection}
                disabled={(this.props.regionList.length === 0 || this.props.disabled)}
            >
                {this._renderList()}
            </Select>
        );
    }

    _renderDropDownArrow = () => {
        const disabled = (this.props.regionList.length === 0 || this.props.disabled);

        const {classes} = this.props;

        const selectState = (disabled) ? classes.selectDisabled : classes.selectDefault;

        return (
            <SvgDropDownArrow className={classNames(classes.selectIcon, selectState)}/>
        );
    }

    _renderList = () => {
        const {classes} = this.props;

        const menuItemClasses = {
            root: classes.selectMenuItem,
            selected: classes.selectSelected,
        }

        if (this.props.regionList.length === 0) {
            return (
                <MenuItem
                    classes={menuItemClasses}
                    value={-1}
                    key={-1}
                >
                    No Region
                </MenuItem>
            );
        }

        return this.props.regionList.map(this._renderListItem);
    }

    _renderListItem = (data, index, arr) => {
        const {classes} = this.props;

        const menuItemClasses = {
            root: classes.selectMenuItem,
            selected: classes.selectSelected,
        }

        return (
            <MenuItem
                classes={menuItemClasses}
                value={index}
                key={data.properties.key}
            >
                {data.properties.name}
            </MenuItem>
        );
    }

    _handleSelection = (event) => {
        if (this.props.onSelect) {
            this.props.onSelect(event.target.value);
        }
    }
}

SelectRegion.propTypes = {
    regionListTimestamp: PropTypes.number.isRequired,
    regionList: PropTypes.arrayOf(PropTypes.object).isRequired,
    regionIndex: PropTypes.number,
    disabled: PropTypes.bool.isRequired,
    onSelect: PropTypes.func,
    onError: PropTypes.func,
}

export default withStyles(styles)(SelectRegion);
